const video = {
    init : () => {
        const video = helper.element("#video");
        const btn = helper.element(".js-play");

        if (video && btn) {
            helper.event(btn, "click touchstart", (e) => {
                video.play();
                btn.style.display = "none";
                video.setAttribute("controls", "controls");
            });
        }
    }
}